var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', [_c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('Title', {
    attrs: {
      "text-start": "",
      "font-weight": 600,
      "font-size": 14,
      "title": "Справка об обучении",
      "append-icon": "mdi-trash-can-outline"
    },
    on: {
      "click:append-outer": _vm.removeTrainingCertificate
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-autocomplete', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.showOrganizationName,
      expression: "!showOrganizationName"
    }],
    attrs: {
      "items": _vm.dictionaries.organization,
      "item-text": "name",
      "clearable": "",
      "outlined": "",
      "rounded": "",
      "dense": "",
      "return-object": "",
      "persistent-hint": "",
      "placeholder": "Выберите из списка",
      "no-data-text": "Не найдено",
      "hint": "Если вы не нашли название университета в выпадающем списке, введите название вручную, нажав на карандаш",
      "append-outer-icon": "mdi-pencil-outline"
    },
    on: {
      "click:append-outer": _vm.changeShowOrganizationName,
      "input": _vm.setTrainingCertificate
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', {
          staticClass: "required"
        }, [_vm._v("Образовательная организация")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.trainingCertificate.organization,
      callback: function callback($$v) {
        _vm.$set(_vm.trainingCertificate, "organization", $$v);
      },
      expression: "trainingCertificate.organization"
    }
  }), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showOrganizationName,
      expression: "showOrganizationName"
    }],
    attrs: {
      "placeholder": "Введите данные",
      "rounded": "",
      "outlined": "",
      "dense": "",
      "append-outer-icon": "mdi-pencil-outline"
    },
    on: {
      "click:append-outer": _vm.changeShowOrganizationName,
      "input": _vm.setTrainingCertificate
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', {
          staticClass: "required"
        }, [_vm._v("Наименование образовательной организации")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.trainingCertificate.organizationName,
      callback: function callback($$v) {
        _vm.$set(_vm.trainingCertificate, "organizationName", $$v);
      },
      expression: "trainingCertificate.organizationName"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": "Введите данные",
      "rounded": "",
      "outlined": "",
      "dense": ""
    },
    on: {
      "input": _vm.setTrainingCertificate
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', {
          staticClass: "required"
        }, [_vm._v("Серия")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.trainingCertificate.series,
      callback: function callback($$v) {
        _vm.$set(_vm.trainingCertificate, "series", $$v);
      },
      expression: "trainingCertificate.series"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": "Введите данные",
      "rounded": "",
      "outlined": "",
      "dense": ""
    },
    on: {
      "input": _vm.setTrainingCertificate
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', {
          staticClass: "required"
        }, [_vm._v("Номер")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.trainingCertificate.number,
      callback: function callback($$v) {
        _vm.$set(_vm.trainingCertificate, "number", $$v);
      },
      expression: "trainingCertificate.number"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('DatePicker', {
    attrs: {
      "label": "Дата выдачи",
      "required": "",
      "prop-date": _vm.trainingCertificate.issueDate
    },
    on: {
      "set-date": _vm.setIssueDate
    }
  })], 1), _c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('FileInput', {
    attrs: {
      "title": "Файл справки об обучении",
      "ref-id": _vm.trainingCertificate.id,
      "ref-class-name": "TrainingCertificate"
    },
    on: {
      "set-files": _vm.setFiles
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }